import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useContext } from 'react';
import Head from 'next/head';
import { Link } from '@scentregroup/shared/link';
import { Box } from '@hub/box';
import { CoreContainer } from '@hub/core-container';
import { H1 } from '@hub/heading';
import { AdTargetingContext, BasicPageContext, CentreContext, CentresContext, NavContext } from '@scentregroup/shared/context';
import { UniversalFooter } from '../../components/universal-footer';
import CVPStrip from '../cvp-strip';
import { useUniversalHeader } from '../universal-header';
import { useTaskHeader } from '../../components/task-header';
import { completelyCanonicalUrl } from '../../helpers/canonical-link';
import TopStrip from '../top-strip';
import useIsTopStripEnabled from '../top-strip/use-is-top-strip-enabled';
import trackClickEvents, { categories, labels } from '../analytics/trackEvents';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function safeMeta(value) {
  return typeof value === 'string' && value === '' ? undefined : value;
}
const handleClickTopStrip = () => {
  trackClickEvents.clicked(categories.UNIVERSAL_HEADER, labels.BENEFITS_STRIP);
};
export default function Layout(_ref) {
  var _metaData$twitter, _safeMeta, _metaData$openGraph, _safeMeta2, _metaData$openGraph2, _safeMeta3, _metaData$openGraph3, _metaData$openGraph4, _metaData$twitter2, _header$data$centres, _header$data;
  let {
    country,
    centre,
    header,
    metaData,
    pageTitle,
    showCVPStrip = true,
    showFooter = true,
    taskMode = false,
    taskHeader,
    children,
    mainStyles,
    topStrip: topStripProps,
    showRobotsMetaTag = true
  } = _ref;
  const [Header, setHeaderNavigationPath] = useUniversalHeader(header);
  const TaskHeader = useTaskHeader(taskHeader);
  const showChrome = !useContext(BasicPageContext);
  const isTopStripEnabled = useIsTopStripEnabled();
  const canonical = safeMeta(metaData === null || metaData === void 0 ? void 0 : metaData.canonical);
  const title = safeMeta(metaData === null || metaData === void 0 ? void 0 : metaData.title);
  const description = safeMeta(metaData === null || metaData === void 0 ? void 0 : metaData.description);
  const twitterCreator = safeMeta(metaData === null || metaData === void 0 || (_metaData$twitter = metaData.twitter) === null || _metaData$twitter === void 0 ? void 0 : _metaData$twitter.creator);
  const openGraphUrl = (_safeMeta = safeMeta(metaData === null || metaData === void 0 || (_metaData$openGraph = metaData.openGraph) === null || _metaData$openGraph === void 0 ? void 0 : _metaData$openGraph.url)) !== null && _safeMeta !== void 0 ? _safeMeta : canonical;
  const openGraphTitle = (_safeMeta2 = safeMeta(metaData === null || metaData === void 0 || (_metaData$openGraph2 = metaData.openGraph) === null || _metaData$openGraph2 === void 0 ? void 0 : _metaData$openGraph2.title)) !== null && _safeMeta2 !== void 0 ? _safeMeta2 : title;
  const openGraphDescription = (_safeMeta3 = safeMeta(metaData === null || metaData === void 0 || (_metaData$openGraph3 = metaData.openGraph) === null || _metaData$openGraph3 === void 0 ? void 0 : _metaData$openGraph3.description)) !== null && _safeMeta3 !== void 0 ? _safeMeta3 : description;
  const openGraphImage = safeMeta(metaData === null || metaData === void 0 || (_metaData$openGraph4 = metaData.openGraph) === null || _metaData$openGraph4 === void 0 ? void 0 : _metaData$openGraph4.image);
  let twitterCard = safeMeta(metaData === null || metaData === void 0 || (_metaData$twitter2 = metaData.twitter) === null || _metaData$twitter2 === void 0 ? void 0 : _metaData$twitter2.card);
  if (openGraphImage) {
    var _twitterCard;
    (_twitterCard = twitterCard) !== null && _twitterCard !== void 0 ? _twitterCard : twitterCard = 'summary_large_image';
  } else if (openGraphTitle || openGraphDescription) {
    var _twitterCard2;
    (_twitterCard2 = twitterCard) !== null && _twitterCard2 !== void 0 ? _twitterCard2 : twitterCard = 'summary';
  }

  // Slightly different from the logic in Westfield Direct layout as it has to deal with legacy canonical support
  const completeCanonical = canonical && completelyCanonicalUrl(canonical, metaData === null || metaData === void 0 ? void 0 : metaData.canonicalParams);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Head, {
      "data-id": "layout_index_Layout_Head",
      children: [title && /*#__PURE__*/_jsx("title", {
        "data-id": "layout_index_Layout_title",
        children: title
      }), description && /*#__PURE__*/_jsx("meta", {
        name: "description",
        content: description,
        "data-id": "layout_index_Layout_meta"
      }, "description"), twitterCreator && /*#__PURE__*/_jsx("meta", {
        name: "twitter:creator",
        content: twitterCreator,
        "data-id": "layout_index_Layout_meta_3"
      }), twitterCard && /*#__PURE__*/_jsx("meta", {
        name: "twitter:card",
        content: twitterCard,
        "data-id": "layout_index_Layout_meta_4"
      }), openGraphUrl && /*#__PURE__*/_jsx("meta", {
        property: "og:url",
        content: openGraphUrl,
        "data-id": "layout_index_Layout_meta_5"
      }), openGraphTitle && /*#__PURE__*/_jsx("meta", {
        property: "og:title",
        content: openGraphTitle,
        "data-id": "layout_index_Layout_meta_6"
      }), openGraphDescription && /*#__PURE__*/_jsx("meta", {
        property: "og:description",
        content: openGraphDescription,
        "data-id": "layout_index_Layout_meta_7"
      }), openGraphImage && /*#__PURE__*/_jsx("meta", {
        property: "og:image",
        content: openGraphImage,
        "data-id": "layout_index_Layout_meta_8"
      }), completeCanonical && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("meta", {
          property: "og:url",
          content: completeCanonical,
          "data-id": "layout_index_Layout_meta_9"
        }, "og:url"), /*#__PURE__*/_jsx("link", {
          rel: "canonical",
          href: completeCanonical,
          "data-id": "layout_index_Layout_link"
        }, "canonical")]
      }), showRobotsMetaTag && /*#__PURE__*/_jsx("meta", {
        name: "robots",
        content: "max-image-preview:large",
        "data-id": "layout_index_Layout_meta"
      })]
    }), /*#__PURE__*/_jsx(CentresContext.Provider, {
      value: (_header$data$centres = header === null || header === void 0 || (_header$data = header.data) === null || _header$data === void 0 ? void 0 : _header$data.centres) !== null && _header$data$centres !== void 0 ? _header$data$centres : [],
      children: /*#__PURE__*/_jsxs(AdTargetingContext.Provider, {
        value: {
          centreSlug: centre === null || centre === void 0 ? void 0 : centre.slug
        },
        children: [/*#__PURE__*/_jsxs("nav", {
          "aria-label": "Header",
          "data-id": "layout_index_Layout_nav",
          children: [showChrome && isTopStripEnabled && topStripProps && /*#__PURE__*/_jsx(TopStrip, _objectSpread(_objectSpread({}, topStripProps), {}, {
            onClick: handleClickTopStrip,
            "data-id": "layout_index_Layout_TopStrip"
          })), showChrome && !isTopStripEnabled && showCVPStrip && /*#__PURE__*/_jsx(CVPStrip, {
            country: country,
            "data-id": "layout_index_Layout_CVPStrip"
          }), showChrome && (taskMode ? /*#__PURE__*/_jsx(TaskHeader, {
            "data-id": "layout_index_Layout_TaskHeader"
          }) : /*#__PURE__*/_jsx(Header, {
            "data-id": "layout_index_Layout_Header"
          })), pageTitle && /*#__PURE__*/_jsx(CoreContainer, {
            "data-id": "layout_index_Layout_CoreContainer",
            children: /*#__PURE__*/_jsx(H1, {
              sx: {
                marginBottom: 'spacing-sm'
              },
              "data-id": "layout_index_Layout_CoreContainer_H1",
              children: pageTitle
            })
          })]
        }), /*#__PURE__*/_jsx("main", {
          id: "main-content",
          style: mainStyles,
          "data-id": "layout_index_Layout_main",
          children: /*#__PURE__*/_jsx(CentreContext.Provider, {
            value: centre,
            children: /*#__PURE__*/_jsx(NavContext.Provider, {
              value: setHeaderNavigationPath,
              children: children
            })
          })
        }), showChrome && showFooter && /*#__PURE__*/_jsx(Box, {
          sx: {
            marginTop: ['spacing-4xl', null, 'spacing-5xl']
          },
          "data-id": "layout_index_Layout_Box",
          children: taskMode ? /*#__PURE__*/_jsx(UniversalFooter, {
            country: country,
            taskMode: true,
            "data-id": "layout_index_Layout_UniversalFooter"
          }) : /*#__PURE__*/_jsx(UniversalFooter, {
            Link: Link,
            centre: centre,
            country: country,
            onFindACentre: () => setHeaderNavigationPath(['find-a-centre']),
            "data-id": "layout_index_Layout_UniversalFooter_22"
          })
        })]
      })
    })]
  });
}